import { httpClient } from "./../src/components/common/dependencies/utils/Api";
import { storage } from "./../src/components/common/dependencies/store/stoarage";
import { toast } from "react-toastify";
import { logoutService } from "./../src/components/common/dependencies/service/logoutService";

export default {
  setupInterceptors: () => {
    httpClient.interceptors.request.use(
      async (config) => {
        let cb = storage.getRefreshToken();
        // if (
        //   config.url.startsWith("https://uat-nmp-api.startupindia.gov.in/") &&
        //   config.url != "https://uat-nmp-api.startupindia.gov.in/v1/auth" &&
        //   config.url !=
        //     "https://uat-nmp-api.startupindia.gov.in/v1/refresh_token"
        // ) {
          if(config.url.trim().startsWith("https://maarg-api.startupindia.gov.in/mentorship-app/")
          && config.url.trim()!="https://maarg-api.startupindia.gov.in/mentorship-app/v1/auth"
          && config.url.trim()!="https://maarg-api.startupindia.gov.in/mentorship-app/v1/refresh_token"){

          if (storage.isLoggedIn()) {
            const token = await logoutService.refreshToken(cb);
            config.headers.Authorization = `Bearer ${token}`;

            // if(config.url.trim() == "https://maarg-test.sensez9.tech/v1/im/messageCount") {
            // }
            return config;
          }

          // const token = storage.getJwtToken();
          // if (token) {
          //   config.headers.Authorization = 'Bearer ' + token;
          // }
        } else {
        }
        return config;
      },
      function (err) {
        return Promise.reject(err);
      }
    );

    httpClient.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          // if(config.url.startsWith("http://localhost:8080/") ) {
          //   localStorage.clear();
          //   sessionStorage.clear();
          // }
        }
        if (error.response && error.response.status === 403) {
          toast.error("");
        }

        return Promise.reject(error);
      }
    );
  },
};
